import {
    QUERY_GET_CUSTOMER_PRICINGS_BY_CUSTOMER,
    QUERY_GET_CUSTOMER_PRICING_BY_ID,
    QUERY_POST_CREATE_CUSTOMER_PRICING,
    QUERY_PUT_EDIT_CUSTOMER_PRICING,
    QUERY_DELETE_CUSTOMER_PRICING
} from '../../fetch/constantQueries';
import { baseThunk } from '../../fetch/basicThunk';

export const getCustomerPricings = baseThunk('customerPricing/getByCustomer', QUERY_GET_CUSTOMER_PRICINGS_BY_CUSTOMER, 'GET');
export const getCustomerPricingById = baseThunk('customerPricing/getById', QUERY_GET_CUSTOMER_PRICING_BY_ID, 'GET');
export const createCustomerPricing = baseThunk('customerPricing/create', QUERY_POST_CREATE_CUSTOMER_PRICING, 'POST');
export const editCustomerPricing = baseThunk('customerPricing/update', QUERY_PUT_EDIT_CUSTOMER_PRICING, 'PUT');
export const deleteCustomerPricing = baseThunk('customerPricing/delete', QUERY_DELETE_CUSTOMER_PRICING, 'DELETE');
